import { Button } from '@mui/material';
import { EDeviceType, useDevice } from 'hooks';
import { IAppointmentCombinedState } from 'models';
import { urlService } from 'services';

export const CallButton = (props: { appointment: IAppointmentCombinedState }) => {
	const { appointment } = props;
	const deviceType = useDevice();
	const isMobileDevice = deviceType === EDeviceType.ANDROID || deviceType === EDeviceType.IOS;
	const canCall = isMobileDevice && !appointment.isMasked && !appointment.isPhoneHidden;
	const handleClick = () => () => {
		const url = urlService.buildCallUrl(appointment.primaryContactPrimaryPhoneNumber);
		window.open(url);
	};

	if (!canCall) return null;

	return (
		<Button
			variant='text'
			onClick={handleClick}
			sx={{
				flex: '1 1 0px',
				borderRadius: '0px 0px 0px 0px',
				minHeight: 50
			}}>
			Call
		</Button>
	);
};
